import { CircularProgress, Box, styled } from "@mui/material";
import { borderRadius } from "@mui/system";
import { MatxLayoutSettings } from "./MatxLayout/settings";

// STYLED COMPONENT
const StyledLoading = styled("div")({
  width: "100%",
  height: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  "& img": {
    width: "auto",
    height: "30px",
    borderRadius: "15px"
  },
  "& .circleProgress": {
    position: "absolute",
    left: -5,
    right: 0,
    top: "calc(50% - 23px)",
    color: MatxLayoutSettings.palette.active,
  }
});

export default function Loading() {
  return (
    <StyledLoading>
      <Box position="relative">
        <img src="/Evento-icon-01.png" alt="" />
        <CircularProgress className="circleProgress" />
      </Box>
    </StyledLoading>
  );
}
